var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEyeGloss = function SvgEyeGloss(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 37,
    height: 19,
    viewBox: "0 0 0.9 0.47",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.86.16.02.02C.9.21.9.24.88.27.88.28.87.29.85.3.82.33.76.37.73.38.57.47.45.49.34.45.24.42.14.35.02.25 0 .23-.01.19.01.16h.01A.58.58 0 0 1 .41 0c.14 0 .28.06.45.16zm-.14 0C.71.22.64.27.57.27.48.27.4.21.4.13.4.11.41.08.42.06c.1.01.19.04.3.1zM.41.41C.33.4.26.35.17.29A.16.16 0 0 1 .28.24c.07 0 .13.07.13.14v.03z",
    fill: "#000"
  })));
};

export default SvgEyeGloss;